import { apiClient } from "./client";

/**
 * RO Reporting Group - deliveries grouped by session and electoral district
 */
export interface RoReportingGroup {
    clientRequestId: string;
    electoralDistrictId?: string | null;
    electoralDistrictName?: string | null;
    electoralDistrictCode?: string | null;
    campaignId: string;
    campaignName: string;
    deliveryCount: number;
    addressCount: number;
    totalQuantity: number;
    firstDeliveredAt: string;
    lastDeliveredAt: string;
    isReportedToRo: boolean;
    reportedToRoAt?: string | null;
    reportedToRoByUserId?: string | null;
    reportedToRoByUserName?: string | null;
    deliveryIds: string[];
}

/**
 * Query parameters for RO reporting
 */
export interface RoReportingQueryParams {
    campaignId?: string;
    electoralDistrictId?: string;
    clientRequestId?: string;
    fromDate?: string;
    toDate?: string;
    isReportedToRo?: boolean;
}

/**
 * Request to mark deliveries as reported to RO
 */
export interface MarkAsReportedToRoRequest {
    deliveryIds: string[];
}

/**
 * Response from marking deliveries as reported
 */
export interface MarkAsReportedToRoResponse {
    updatedCount: number;
}

/**
 * Gets deliveries grouped for RO reporting
 */
export const getRoReportingGroups = async (
    params?: RoReportingQueryParams
): Promise<RoReportingGroup[]> => {
    const searchParams = new URLSearchParams();
    if (params?.campaignId) searchParams.append("campaignId", params.campaignId);
    if (params?.electoralDistrictId) searchParams.append("electoralDistrictId", params.electoralDistrictId);
    if (params?.clientRequestId) searchParams.append("clientRequestId", params.clientRequestId);
    if (params?.fromDate) searchParams.append("fromDate", params.fromDate);
    if (params?.toDate) searchParams.append("toDate", params.toDate);
    if (params?.isReportedToRo !== undefined) {
        searchParams.append("isReportedToRo", params.isReportedToRo.toString());
    }

    const queryString = searchParams.toString();
    const url = `/ro-reporting/deliveries${queryString ? `?${queryString}` : ""}`;

    const { data } = await apiClient.get<RoReportingGroup[]>(url);
    return data;
};

/**
 * Marks deliveries as reported to RO
 */
export const markAsReportedToRo = async (
    request: MarkAsReportedToRoRequest
): Promise<MarkAsReportedToRoResponse> => {
    const { data } = await apiClient.post<MarkAsReportedToRoResponse>(
        "/ro-reporting/mark-reported",
        request
    );
    return data;
};
